export const formatCurrency = (value) => {
  if (value === undefined || value === null || isNaN(value)) return '-';
  return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(value);
};

export const formatDateTime = (isoString) => {
  if (!isoString || typeof isoString !== 'string') {
    return 'N/A';
  }
  try {
    const date = new Date(isoString + 'Z'); // Asegura que se trate como UTC
    return date.toLocaleString('es-CO', { timeZone: 'America/Bogota' });
  } catch (error) {
    console.error("Error al formatear la fecha:", error);
    return 'Fecha inválida';
  }
};

export const getPriceListDisplayName = (listName) => {
  const mapping = {
    'PrecioLista10': 'Contado', 'PL10': 'Contado',
    'PrecioLista1': 'Crédito', 'PL1': 'Crédito',
    'PrecioLista2': 'Lista 2', 'PL2': 'Lista 2',
    'PrecioLista4': 'CEDI', 'PL4': 'CEDI'
  };
  return mapping[listName] || listName;
};